/**
 * Common translations
 * Includes: Button text, status messages, error messages
 */
export default {
  confirm: 'Confirm',
  cancel: 'Cancel',
  purchase: 'Purchase',
  loading: 'Loading...',
  waiting: 'Waiting...',
  initializing: 'Initializing...',
  refreshSuccess: 'Refresh success',
  copySuccess: 'Copied',
  pricePerMin: '{price}/min',
  and: ' and ',
  youBlockedUser: 'You have blocked this user',
  youBeenBlocked: 'You have been blocked by this user',
  days: {
    "1": "{days} day",
    "other": "{days} days"
  },
  busy: 'busy',
  // Pull refresh related
  pullRefresh: {
    finishedText: 'No more data',
    errorText: 'Load failed, click to retry',
    pullingText: 'Pull to refresh...',
    loosingText: 'Release to refresh...',
  },
  // Request related errors
  request: {
    networkError: 'Network error, please check your connection',
    timeout: 'Request timeout',
    serverError: 'Server error',
    unauthorized: 'Unauthorized, please login again',
    forbidden: 'Access denied',
    notFound: 'Resource not found',
    badRequest: 'Bad request parameters',
    gatewayError: 'Gateway error',
    serviceUnavailable: 'Service unavailable',
    gatewayTimeout: 'Gateway timeout',
    requestError: 'Request error',
    tokenExpired: 'Login expired, please login again',
  },
  suspendedPopup: {
    title: 'Your account has been suspended',
    message: 'Your account has been suspended, please try again later',
  },
  // Zodiac signs
  zodiac: {
    capricornus: 'Capricornus',
    aquarius: 'Aquarius',
    pisces: 'Pisces',
    aries: 'Aries',
    taurus: 'Taurus',
    gemini: 'Gemini',
    cancer: 'Cancer',
    leo: 'Leo',
    virgo: 'Virgo',
    libra: 'Libra',
    scorpio: 'Scorpio',
    sagittarius: 'Sagittarius',
  },
  // Permissions
  permissions: {
    camera: 'Camera',
    microphone: 'Microphone',
  },
  permissionDenied: {
    title: 'Permission Denied',
    message: 'Cannot use {permissions}. Please allow access in browser settings',
  },
  // Insufficient balance error
  insufficientBalance: {
    title: 'Insufficient Balance',
    message: 'Your diamond balance is insufficient. Please recharge or subscribe to VIP for privileges',
    recharge: 'Recharge',
    vip: 'Subscribe VIP',
  },
  // Online status
  onlineStatus: {
    online: 'Online',
    busy: 'Busy',
    active: 'Active',
    offline: 'Offline',
    live: 'Live',
  },
  // Special conversation names
  specialConvName: {
    'System Notification': 'System Notification',
    'Customer Service': 'Customer Service',
    'Misslive Team': 'Misslive Team',
    'Stranger Messages': 'Stranger Messages',
  },
  // Inactive tab dialog
  inactiveTab: {
    title: 'Notice',
    message: 'The app is already open in another tab. This tab is inactive and cannot perform login or other operations. Please close other tabs or use the already opened tab.',
    confirm: 'Got it',
  },
  // Error messages
  error: {
    dbInitFailed: 'Database initialization failed, please try again',
    loadConversationsFailed: 'Failed to load conversations',
    imConnectFailed: 'Failed to connect to IM',
    appInitFailed: 'Application initialization failed',
  },
  // Security messages
  security: {
    devtoolDetected: 'Developer tools detected. For user privacy and data security, the page will be redirected',
  },
}
